export const SortArrows = ({ className, ...rest }: { className?: string } & Partial<HTMLOrSVGElement>) => (
  <svg
    {...(className && { className })}
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M7 15L12 20L17 15" stroke="#02052B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 9L12 4L7 9" stroke="#02052B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
